var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCompleteTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "grid"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,11.5c-0.276,0-0.5,0.224-0.5,0.5c0,6.065-4.935,11-11,11S1,18.065,1,12S5.935,1,12,1   c3.498,0,6.775,1.661,8.848,4.464l-9.566,9.566l-3.529-3.529c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l3.883,3.883   c0.195,0.195,0.512,0.195,0.707,0L21.854,5.872c0.17-0.17,0.195-0.438,0.059-0.636C19.672,1.958,15.966,0,12,0   C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12C24,11.724,23.776,11.5,23.5,11.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompleteTimer);
export default __webpack_public_path__ + "static/media/iconCompleteTimer.7af02aedb4d3d347e2ff932020348954.svg";
export { ForwardRef as ReactComponent };